import { Action } from 'redux';
import * as ColumnsActions from './columns.actions';

export interface ColumnsEntities {
  [id: string]: any;
}

export interface ColumnsState {
  entities: ColumnsEntities;
}

const initialState: ColumnsState = {
  entities: {}
};

export const ColumnsReducer =
  function (state: ColumnsState = initialState, action: Action): ColumnsState {
    switch (action.type) {

      case ColumnsActions.LOAD_COLUMNS_CONFIG: {
        const columns = (<ColumnsActions.LoadColumnsConfigAction>action).columns;
        return {
          entities: Object.assign({}, columns)
        };
      }

      case ColumnsActions.ADD_COLUMNS_CONFIG: {
        const name = (<ColumnsActions.AddColumnsConfigAction>action).config.name;
        const columns = (<ColumnsActions.AddColumnsConfigAction>action).config.value;
        return {
          entities: Object.assign({}, state.entities, {
            [name]: columns
          })
        };
      }
      case ColumnsActions.UPDATE_COLUMNS_CONFIG: {
        const name = (<ColumnsActions.UpdateColumnsConfigAction>action).config.name;
        const columns = (<ColumnsActions.UpdateColumnsConfigAction>action).config.value;
        return {
          entities: Object.assign({}, state.entities, {
            [name]: columns
          })
        };
      }
      default:
        return state;
    }
  };
